import { render, staticRenderFns } from "./Snapshot.vue?vue&type=template&id=b7045e1e&scoped=true"
import script from "./Snapshot.vue?vue&type=script&lang=js"
export * from "./Snapshot.vue?vue&type=script&lang=js"
import style0 from "./Snapshot.vue?vue&type=style&index=0&id=b7045e1e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7045e1e",
  null
  
)

export default component.exports